/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useAuth } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/auth';

const useStyles = makeStyles((theme) => ({
    btnSignIn: {
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 'bold',
        padding: '0',
        color: theme.palette.colorInfo,
        textAlign: 'right',
        lineHeight: '18px',
    },
}));

const LimitedAccessReSignInLink = () => {
    const classes = useStyles();

    const { loginByRedirect } = useAuth();
    const handleClick = async () => {
        await loginByRedirect();
    };

    return (
        <Button className={classes.btnSignIn} onClick={handleClick}>
            Confirm your account to access your address book
        </Button>
    );
};

export default LimitedAccessReSignInLink;
